<script>
import InputText from '@/components/InputText.vue';

/**
 * @description Поле ввода СНИЛС.
 * @type {Vue}
 */
export default {
  name: 'InputSnils',
  props: {
    /**
     * @description Опциональный ввод.
     */
    optional: {
      default: () => false,
      required: false,
      type: Boolean,
    },
    /**
     * @description Заполнитель.
     */
    placeholder: {
      default: () => 'СНИЛС',
      required: false,
      type: String,
    },
    /**
     * @description Заголовок.
     */
    title: {
      default: () => 'СНИЛС',
      required: false,
      type: String,
    },
    /**
     * @description Значение.
     */
    value: {
      required: true,
      type: String,
    },
    /**
     * @description Нарушения.
     */
    violations: {
      default: () => [],
      required: false,
      type: Array,
    },
  },
  render(createElement) {
    return createElement(InputText, {
      directives: [
        {
          name: 'facade',
          value: this.$options.snilsMaskWithDelimitersChars,
        },
      ],
      on: {
        input: (updatedValue) => this.$emit('input', updatedValue),
        invalid: (...args) => this.$emit('invalid', ...args),
      },
      props: {
        pattern: this.$options.snilsPatternWithDelimiters,
        placeholder: this.placeholder,
        required: !this.optional,
        title: this.title,
        value: this.value,
        violations: this.violations,
      },
    });
  },
  snilsMaskWithDelimitersChars: '###-###-### ##',
  snilsPatternWithDelimiters: '^[0-9]{3}-[0-9]{3}-[0-9]{3} [0-9]{2}$',
};
</script>
